<template>
    <div :class="$style.container">
        <Typography
            is="h2"
            size="l"
            type="paragraph"
            :class="$style.videoCaption"
        >
            {{ `${tr('seo.gameplay_video')}` }}
        </Typography>

        <div v-if="props.videoType === 'youtube'">
            <div :class="$style.youtubeVideoContainer">
                <iframe
                    loading="lazy"
                    :class="$style.youtubeVideoIframe"
                    :src="videoUrl"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                />
                >
            </div>
        </div>
        <div
            v-else-if="props.videoType === 'player'"
            :class="$style.videoContainer"
        >
            <div :class="$style.videoItem">
                <div :class="$style.videoWrapper">
                    <div :class="$style.responsiveWrapper">
                        <video
                            :poster="posterUrl"
                            :class="$style.videoPlayer"
                            controls
                            preload="none"
                        >
                            <source
                                :src="videoUrl"
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'

export type SeoVideoType = 'youtube' | 'player'

const props = defineProps<{
    videoType: SeoVideoType
    posterUrl?: string
    videoUrl: string
}>()

const tr = useTr()
</script>
<style module>
.videoContainer {
    position: relative;
    border-radius: 8px;
}
.videoItem {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;

    border-radius: 8px;

    width: 100%;
    max-width: 711px;
    padding-top: 10px;
}

.videoCaption {
    text-transform: capitalize;
}

.container {
    padding-top: 30px;
}

.videoWrapper {
    width: 100%;
    margin: 0 auto;
}

.responsiveWrapper {
    position: relative;
    padding-top: calc(100% * 9 / 16);
}

.videoPlayer {
    border: none;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.youtubeVideoContainer {
    width: 100%;
    max-width: 711px;
    aspect-ratio: 16 / 9;
    max-height: 400px;
    margin: 0;
    overflow: hidden;
    padding-top: 10px;
}

.youtubeVideoIframe {
    border-radius: 15px;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
